import { render, staticRenderFns } from "./FormulationQcTestTab.vue?vue&type=template&id=6b0d75a3&scoped=true&"
import script from "./FormulationQcTestTab.vue?vue&type=script&lang=js&"
export * from "./FormulationQcTestTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationQcTestTab.vue?vue&type=style&index=0&id=6b0d75a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0d75a3",
  null
  
)

export default component.exports